import BlockedSubscription from 'components/molecules/blocked_subscription';
import BlockedSubscriptionRepresentant from 'components/molecules/blocked_subscription_representant';
import MarketSearch from 'components/molecules/market_search';
import DashboardMarket from 'components/organisms/dashboard_market';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import companyId from 'services/company_id';
import tabId from 'services/tabId';
import { ApplicationState } from 'store';
import { getClientFilters } from 'store/modules/market_store/actions';
import { MarketState } from 'store/modules/market_store/types';
import { ProfileState } from 'store/modules/profile_store/types';

const Market = () => {
  const { get_filters } = useSelector<ApplicationState, MarketState>(
    (state) => state.session.market,
  );
  const dispatch = useDispatch();
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const [searchBarOpened, setSearchBarOpened] = useState<boolean>(true);
  const [exactSearch, serExactSearch] = useState<boolean>(true);
  const [selectedPeriod, setSelectedPeriod] = useState<Array<object> | number>(12);
  const [selectedFilter, setSelectedFilter] = useState<number>(
    get_filters && get_filters[0]?.filter?.id,
  );
  const [advanced_search, serAdvancedSearch] = useState<boolean>(false);
  const [params, setParams] = useState<any>({});
  const allowedSaleSituations = ['Ativa', 'Em Analise'];

  useEffect(() => {
    document.title = 'Análise de Mercado - ConLicitação';
    const params = {
      filter_id: selectedFilter,
      interval: selectedPeriod,
      exact_search: exactSearch,
      advanced_search,
    };
    setParams(params);
  }, [selectedFilter]);

  useEffect(() => {
    setSelectedFilter(get_filters && get_filters[0]?.filter?.id);
    dispatch(getClientFilters(companyId(profile)));
  }, [get_filters && get_filters[0]?.filter?.id, profile.currentCompany[tabId()]]);

  return (
    <div className="page-container pr-0 pr-md-3">
      {!profile.representant &&
        allowedSaleSituations.includes(profile.sale_situation) &&
        !profile.paralyzed && (
          <>
            <MarketSearch
              setSearchBarOpened={setSearchBarOpened}
              searchBarOpened={searchBarOpened}
              setSelectedPeriod={setSelectedPeriod}
              selectedPeriod={selectedPeriod}
              exactSearch={exactSearch}
              serExactSearch={serExactSearch}
              advanced_search={advanced_search}
              serAdvancedSearch={serAdvancedSearch}
              setParams={setParams}
            />
            <DashboardMarket
              searchBarOpened={searchBarOpened}
              selectedPeriod={selectedPeriod}
              selectedFilter={selectedFilter}
              exactSearch={exactSearch}
              params={params}
            />
          </>
        )}
      {!profile.representant && !allowedSaleSituations.includes(profile.sale_situation) && (
        <BlockedSubscription paralyzed={profile.paralyzed} />
      )}
      {profile.representant &&
        allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) &&
        !profile.represented.filter((company) => company.id === profile.currentCompany[tabId()])[0]
          ?.paralisado && (
          <>
            <MarketSearch
              setSearchBarOpened={setSearchBarOpened}
              searchBarOpened={searchBarOpened}
              setSelectedPeriod={setSelectedPeriod}
              selectedPeriod={selectedPeriod}
              exactSearch={exactSearch}
              serExactSearch={serExactSearch}
              advanced_search={advanced_search}
              serAdvancedSearch={serAdvancedSearch}
              setParams={setParams}
            />
            <DashboardMarket
              searchBarOpened={searchBarOpened}
              selectedPeriod={selectedPeriod}
              selectedFilter={selectedFilter}
              exactSearch={exactSearch}
              params={params}
            />
          </>
        )}
      {profile.representant &&
        profile.currentCompany[tabId()] !== profile.clientId &&
        profile.represented.filter((company) => company.id === profile.currentCompany[tabId()])[0]
          ?.paralisado &&
        allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) && <BlockedSubscriptionRepresentant />}
      {profile.representant &&
        profile.currentCompany[tabId()] !== profile.clientId &&
        !allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) && <BlockedSubscriptionRepresentant />}
    </div>
  );
};
export { Market };
